export const navLinks = [
    { name: 'Specialities', to: '/specialities' },
    { name: 'Gallery', to: '/gallery' },
    { name: 'Awards', to: '/awards' },
    { name: 'About', to: '/about' },
    { name: 'Contact', to: '/contact' },
];
